import { captureException } from '@sentry/react';

import { resolvedAvailableSitesProvider } from '@townsquare/available-sites-provider/provider';
import { resolvedCollabGraphProvider } from '@townsquare/collab-graph-provider';
import type { CollaborationGraphContainer } from '@townsquare/collab-graph-provider/types';
import { fg } from '@townsquare/stat-sig/gate';

export const fetchWhereYouWorkContainers = async ({
	cloudIdsToFilterFor,
	orgId,
	accountId,
}: {
	cloudIdsToFilterFor?: string[];
	orgId: string;
	accountId: string;
}): Promise<CollaborationGraphContainer[]> => {
	const { data: apsData, error: apsError } =
		cloudIdsToFilterFor && fg('townsquare_where_you_work_preload')
			? { data: cloudIdsToFilterFor, error: null }
			: await resolvedAvailableSitesProvider.getAvailableSitesCloudIds({
					cloudIdsToFilterFor,
					orgId,
				});

	if (!apsData.length) {
		if (apsError) {
			const error = new Error(
				'useWhereYouWorkContainers: failed to load available sites cloud ids',
			);
			captureException(error, {
				tags: { source: 'useWhereYouWorkContainers', provider: 'availableSitesProvider' },
			});

			throw error;
		}

		return [];
	}
	const { data, error } = await resolvedCollabGraphProvider.getCollabGraphContainers(
		accountId,
		apsData,
	);
	if (error) {
		const containerError = new Error(
			'useWhereYouWorkContainers: failed to load collab graph containers',
		);
		captureException(containerError, {
			tags: { source: 'useWhereYouWorkContainers', provider: 'collabGraphProvider' },
		});

		throw containerError;
	}
	return data;
};
